import * as i0 from '@angular/core';
import { Injectable, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, EventEmitter, forwardRef, ElementRef, Optional, Input, Output, ViewChild, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import * as i1$1 from '@angular/material/core';
import { MAT_DATE_FORMATS, MatNativeDateModule } from '@angular/material/core';
import * as i1 from '@angular/material/datepicker';
import { DateRange, MAT_DATE_RANGE_SELECTION_STRATEGY, MatCalendar, MatDatepickerModule } from '@angular/material/datepicker';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i3 from '@niceltd/sol/button';
import { ButtonModule } from '@niceltd/sol/button';
import * as i4 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import { CommonModule } from '@angular/common';
function CalendarHeaderComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 6);
    i0.ɵɵelement(1, "path", 7);
    i0.ɵɵelementEnd();
  }
}
function CalendarHeaderComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 6);
    i0.ɵɵelement(1, "path", 8);
    i0.ɵɵelementEnd();
  }
}
const _c0 = ["cal"];
var calendarClassEnum;
(function (calendarClassEnum) {
  calendarClassEnum["MAT_CALENDAR_BODY_RANGE_START"] = "mat-calendar-body-range-start mat-calendar-body-in-range sol-date-selected sol-week-selected ";
  calendarClassEnum["MAT_CALENDAR_BODY_RANGE_END"] = "mat-calendar-body-range-end mat-calendar-body-in-range sol-date-selected sol-week-selected ";
  calendarClassEnum["MAT_CALENDAR_BODY_RANGE"] = "mat-calendar-body-in-range sol-date-selected sol-week-selected ";
  calendarClassEnum["MAT_CALENDAR_BODY_IN_RANGE"] = "mat-calendar-body-in-range sol-date-selected sol-week-selected";
  calendarClassEnum["MAT_CALENDAR_BODY_CELL_START"] = "mat-calendar-body-cell mat-calendar-body-range-start mat-calendar-body-in-range mat-calendar-body-active";
  calendarClassEnum["MAT_CALENDAR_BODY_CELL_END"] = "mat-calendar-body-cell mat-calendar-body-range-end mat-calendar-body-in-range mat-calendar-body-active";
  calendarClassEnum["MAT_CALENDAR_BODY_CELL"] = "mat-calendar-body-cell mat-calendar-body-in-range";
})(calendarClassEnum || (calendarClassEnum = {}));
class CalendarService {
  get state() {
    return this.state$.getValue();
  }
  constructor() {
    this.state$ = new BehaviorSubject(null);
    this.selectedWeek = new DateRange(null, null);
    this.multiWeek = [];
    this.selectedDateRange = new DateRange(null, null);
  }
  setState(newState) {
    this.state$.next({
      ...this.state,
      ...newState
    });
  }
  addWeek(weekArr, selectedDate) {
    const dow = this.state.dateAdapter.getDayOfWeek(selectedDate) + 1;
    const startTemp = this.state.dateAdapter.addCalendarDays(selectedDate, -(dow + 6 - this.state.startingDay) % 7);
    const endTemp = this.state.dateAdapter.addCalendarDays(startTemp, 6);
    const temp = new DateRange(startTemp, endTemp);
    const start = weekArr.some(el => el.start.toISOString() === temp.start?.toISOString());
    const end = weekArr.some(el => el.end.toISOString() === temp.end?.toISOString());
    if (!start && !end) {
      weekArr.push(temp);
      this.selectedWeek = weekArr[0];
      return weekArr;
    } else {
      let i = weekArr.length;
      while (i--) {
        if (weekArr[i] && weekArr[i].start.toISOString() === temp.start?.toISOString()) {
          weekArr.splice(i, 1);
          this.selectedWeek = weekArr[0];
          return weekArr;
        }
      }
    }
    return weekArr;
  }
  selectWeek(selectedDate) {
    const dow = this.state.dateAdapter.getDayOfWeek(selectedDate) + 1;
    const startTemp = this.state.dateAdapter.addCalendarDays(selectedDate, -(dow + 6 - this.state.startingDay) % 7);
    const endTemp = this.state.dateAdapter.addCalendarDays(startTemp, 6);
    this.selectedWeek = new DateRange(startTemp, endTemp);
    return this.selectedWeek;
  }
  multiSingleSelectionHandler(selectedDate) {
    if (!this.dayselect) {
      this.dayselect = [];
    }
    const index = this.dayselect.findIndex(x => x.getTime() === selectedDate.getTime());
    if (index < 0) {
      this.dayselect.push(selectedDate);
    } else {
      this.dayselect.splice(index, 1);
    }
    return this.dayselect;
  }
  weekSelectionHandler(selectedDate) {
    if (selectedDate) {
      this.state._rangeSelectionStrategy.selectionFinished(selectedDate);
      return this.selectWeek(selectedDate);
    }
    return null;
  }
  multiWeekSelectionHandler(selectedDate) {
    if (selectedDate) {
      this.state._rangeSelectionStrategy.selectionFinished(selectedDate);
      const selectedValue = this.addWeek(this.multiWeek, selectedDate);
      return selectedValue;
    }
    return null;
  }
  rangeSelectionHandler(selectedDate) {
    if (this.selectedDateRange && selectedDate && this.selectedDateRange.start && selectedDate >= this.selectedDateRange.start && !this.selectedDateRange.end) {
      this.selectedDateRange = new DateRange(this.selectedDateRange.start, selectedDate);
      return this.selectedDateRange;
    } else {
      if (!this.selectedDateRange.start && this.selectedDateRange.end) {
        this.selectedDateRange = new DateRange(selectedDate, this.selectedDateRange.end);
        return this.selectedDateRange;
      }
      this.selectedDateRange = new DateRange(selectedDate, null);
      return this.selectedDateRange;
    }
  }
  selectedChangeHandler(selectedDate) {
    if (this.state.type === 'single-selection' && selectedDate) {
      this.selectedDate = selectedDate;
      return this.selectedDate;
    } else if (this.state.type === 'multi-single-selection' && selectedDate) {
      return this.multiSingleSelectionHandler(selectedDate);
    } else if (this.state.type === 'week-selection' && selectedDate) {
      return this.weekSelectionHandler(selectedDate);
    } else if (this.state.type === 'multi-week-selection' && selectedDate) {
      return this.multiWeekSelectionHandler(selectedDate);
    } else {
      return this.rangeSelectionHandler(selectedDate);
    }
  }
  weekSelection(date) {
    if (this.state.calendar.currentView === 'month') {
      if (date && this.selectedWeek?.start && this.selectedWeek?.end) {
        if (date.toISOString() === this.selectedWeek.start.toISOString()) {
          return calendarClassEnum.MAT_CALENDAR_BODY_RANGE_START;
        } else if (date.toISOString() === this.selectedWeek.end.toISOString()) {
          return calendarClassEnum.MAT_CALENDAR_BODY_RANGE_END;
        } else if (date >= this.selectedWeek.start && date <= this.selectedWeek.end) {
          if (date.getDate() === 1) {
            return calendarClassEnum.MAT_CALENDAR_BODY_RANGE + ' sol-first-date-of-month';
          }
          return calendarClassEnum.MAT_CALENDAR_BODY_RANGE;
        }
      }
    }
    return '';
  }
  multiWeekSelection(date) {
    return this.multiWeek.map(dateRange => {
      if (this.state.calendar.currentView === 'month') {
        if (date && dateRange?.start && dateRange.end) {
          if (date.toISOString() === dateRange.start.toISOString()) {
            return calendarClassEnum.MAT_CALENDAR_BODY_RANGE_START;
          } else if (date.toISOString() === dateRange.end.toISOString()) {
            return calendarClassEnum.MAT_CALENDAR_BODY_RANGE_END;
          } else if (date >= dateRange.start && date <= dateRange.end) {
            if (date.getDate() === 1) {
              return calendarClassEnum.MAT_CALENDAR_BODY_RANGE + ' sol-first-date-of-month';
            }
            return calendarClassEnum.MAT_CALENDAR_BODY_IN_RANGE;
          }
        }
      }
      return '';
    });
  }
  multiSingleSelection(date) {
    if (this.state.calendar.currentView === 'month') {
      const formattedDate = date.getFullYear() + '-' + ('00' + (date.getMonth() + 1)).slice(-2) + '-' + ('00' + date.getDate()).slice(-2);
      return this.dayselect.find(x => x.getFullYear() + '-' + ('00' + (x.getMonth() + 1)).slice(-2) + '-' + ('00' + x.getDate()).slice(-2) === formattedDate) ? 'sol-date-selected' : '';
    } else if (this.state.calendar.currentView === 'year') {
      return this.dayselect.find(x => x.getMonth() === date.getMonth() && x.getFullYear() === date.getFullYear()) ? 'mat-calendar-body-cell mat-calendar-body-active' : '';
    } else if (this.state.calendar.currentView === 'multi-year') {
      return this.dayselect.find(x => x.getFullYear() === date.getFullYear()) ? 'mat-calendar-body-cell mat-calendar-body-active' : '';
    }
    return '';
  }
  rangeSelection(date) {
    if (this.state.calendar.currentView === 'month') {
      if (date?.toISOString() === this.selectedDateRange?.start?.toISOString() && date?.toISOString() === this.selectedDateRange?.end?.toISOString()) {
        return 'sol-date-selected';
      } else if (date && date.toISOString() === this.selectedDateRange?.start?.toISOString()) {
        return calendarClassEnum.MAT_CALENDAR_BODY_CELL_START;
      } else if (date && this.selectedDateRange?.end && date?.toISOString() > this.selectedDateRange?.start?.toISOString() && date?.toISOString() < this.selectedDateRange?.end?.toISOString()) {
        if (date.getDate() === 1) {
          return calendarClassEnum.MAT_CALENDAR_BODY_CELL + ' sol-first-date-of-month-range';
        }
        return calendarClassEnum.MAT_CALENDAR_BODY_CELL;
      } else if (date && this.selectedDateRange?.end && date.toISOString() === this.selectedDateRange?.end.toISOString()) {
        return calendarClassEnum.MAT_CALENDAR_BODY_CELL_END;
      }
    }
    return '';
  }
  selected(date) {
    if (this.state) {
      if (this.state.type === 'multi-single-selection' && this.dayselect) {
        return this.multiSingleSelection(date);
      } else if (this.state.type === 'week-selection' && this.selectedWeek) {
        return this.weekSelection(date);
      } else if (this.state.type === 'multi-week-selection' && this.selectedWeek) {
        return this.multiWeekSelection(date);
      } else if (this.state.type === 'single-selection' && this.selectedDate) {
        if (this.state.calendar.currentView === 'month') {
          if (this.selectedDate === date) {
            return 'sol-date-selected';
          }
        } else if (this.state.calendar.currentView === 'year') {
          if (this.selectedDate.getMonth() === date.getMonth()) {
            return 'mat-calendar-body-cell mat-calendar-body-active';
          }
        } else if (this.state.calendar.currentView === 'multi-year') {
          if (this.selectedDate.getFullYear() === date.getFullYear()) {
            return 'mat-calendar-body-cell mat-calendar-body-active';
          }
        }
      } else if (this.state.type === 'range-selection') {
        return this.rangeSelection(date);
      }
      return '';
    }
    return '';
  }
  static {
    this.ɵfac = function CalendarService_Factory(t) {
      return new (t || CalendarService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CalendarService,
      factory: CalendarService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarService, [{
    type: Injectable
  }], () => [], null);
})();
class CalendarHeaderComponent {
  constructor(_calendar, _dateAdapter, _dateFormats, cdr) {
    this._calendar = _calendar;
    this._dateAdapter = _dateAdapter;
    this._dateFormats = _dateFormats;
    this._destroyed = new Subject();
    _calendar.stateChanges.pipe(takeUntil(this._destroyed)).subscribe(() => cdr.markForCheck());
  }
  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }
  minMonth() {
    if (this._calendar.minDate) {
      return this._dateAdapter.format(this._calendar.minDate, this._dateFormats.display.monthYearA11yLabel) === this.periodLabel;
    }
    return false;
  }
  maxMonth() {
    if (this._calendar.maxDate) {
      return this._dateAdapter.format(this._calendar.maxDate, this._dateFormats.display.monthYearA11yLabel) === this.periodLabel;
    }
    return false;
  }
  get periodLabel() {
    if (!this._calendar.activeDate) {
      this._calendar.activeDate = new Date();
    }
    return this._dateAdapter.format(this._calendar.activeDate, this._dateFormats.display.monthYearA11yLabel);
  }
  changeView() {
    if (this._calendar.currentView === 'multi-year') {
      this._calendar.currentView = 'month';
    } else {
      this._calendar.currentView = 'multi-year';
    }
  }
  previousClicked() {
    this._calendar.activeDate = this._calendar.currentView === 'month' ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, -1) : this._dateAdapter.addCalendarYears(this._calendar.activeDate, -1);
    this._calendar.monthSelected.emit();
  }
  nextClicked() {
    this._calendar.activeDate = this._calendar.currentView === 'month' ? this._dateAdapter.addCalendarMonths(this._calendar.activeDate, 1) : this._dateAdapter.addCalendarYears(this._calendar.activeDate, 1);
    this._calendar.monthSelected.emit();
  }
  static {
    this.ɵfac = function CalendarHeaderComponent_Factory(t) {
      return new (t || CalendarHeaderComponent)(i0.ɵɵdirectiveInject(i1.MatCalendar), i0.ɵɵdirectiveInject(i1$1.DateAdapter), i0.ɵɵdirectiveInject(MAT_DATE_FORMATS), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalendarHeaderComponent,
      selectors: [["sol-calendar-header"]],
      decls: 12,
      vars: 20,
      consts: [[1, "sol-calendar-header"], ["previousIcon", ""], ["nextIcon", ""], [3, "variant", "size", "ariaLabel", "iconPositionedFront", "disabled", "disabledAltState", "onClick"], [1, "sol-calendar-header-label"], [3, "variant", "size", "ariaLabel", "onClick"], ["width", "6.4", "height", "12.8", "viewBox", "0 0 8 14", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["d", "M0.981181 6.20399L6.11326 0.791051C6.35477 0.536325 6.77741 0.536325 7.01892 0.791051C7.26043 1.04578 7.26043 1.49155 7.01892 1.74627L2.18873 6.8408L7.01892 12.2537C7.26043 12.5085 7.26043 12.9542 7.01892 13.209C6.77741 13.4637 6.35477 13.4637 6.11326 13.209L0.981181 7.47762C0.800049 7.28657 0.800049 7.09553 0.800049 6.90448C0.800049 6.58608 0.860426 6.33135 0.981181 6.20399Z", "fill", "currentColor"], ["d", "M7.01892 6.20399L1.88684 0.791051C1.64533 0.536325 1.22269 0.536325 0.981181 0.791051C0.739671 1.04578 0.739671 1.49155 0.981181 1.74627L5.81137 6.8408L0.981181 12.2537C0.739671 12.5085 0.739671 12.9542 0.981181 13.209C1.22269 13.4637 1.64533 13.4637 1.88684 13.209L7.01892 7.47762C7.20005 7.28657 7.20005 7.09553 7.20005 6.90448C7.20005 6.58608 7.13967 6.33135 7.01892 6.20399Z", "fill", "currentColor"]],
      template: function CalendarHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, CalendarHeaderComponent_ng_template_1_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(3, CalendarHeaderComponent_ng_template_3_Template, 2, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementStart(5, "sol-button", 3);
          i0.ɵɵlistener("onClick", function CalendarHeaderComponent_Template_sol_button_onClick_5_listener() {
            return ctx.previousClicked();
          });
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "span", 4)(8, "sol-button", 5);
          i0.ɵɵlistener("onClick", function CalendarHeaderComponent_Template_sol_button_onClick_8_listener() {
            return ctx.changeView();
          });
          i0.ɵɵtext(9);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(10, "sol-button", 3);
          i0.ɵɵlistener("onClick", function CalendarHeaderComponent_Template_sol_button_onClick_10_listener() {
            return ctx.nextClicked();
          });
          i0.ɵɵpipe(11, "translate");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const _r1 = i0.ɵɵreference(2);
          const _r3 = i0.ɵɵreference(4);
          i0.ɵɵadvance(5);
          i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(6, 16, "previousButton"));
          i0.ɵɵproperty("variant", "text")("size", "large")("iconPositionedFront", _r1)("disabled", ctx.minMonth())("disabledAltState", ctx.minMonth());
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("variant", "text")("size", "large")("ariaLabel", ctx.periodLabel);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.periodLabel);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("ariaLabel", i0.ɵɵpipeBind1(11, 18, "nextButton"));
          i0.ɵɵproperty("variant", "text")("size", "large")("iconPositionedFront", _r3)("disabled", ctx.maxMonth())("disabledAltState", ctx.maxMonth());
        }
      },
      dependencies: [i3.ButtonComponent, i4.TranslationPipe],
      styles: [".sol-calendar-header{display:flex;align-items:center;padding:1rem .625rem}.sol-calendar-header .sol-calendar-header-label{flex:1;text-align:center;padding-left:.125rem}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'sol-calendar-header',
      template: `
    <div class="sol-calendar-header">
      <ng-template #previousIcon>
        <svg width="6.4" height="12.8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.981181 6.20399L6.11326 0.791051C6.35477 0.536325 6.77741 0.536325 7.01892 0.791051C7.26043 1.04578 7.26043 1.49155 7.01892 1.74627L2.18873 6.8408L7.01892 12.2537C7.26043 12.5085 7.26043 12.9542 7.01892 13.209C6.77741 13.4637 6.35477 13.4637 6.11326 13.209L0.981181 7.47762C0.800049 7.28657 0.800049 7.09553 0.800049 6.90448C0.800049 6.58608 0.860426 6.33135 0.981181 6.20399Z"
            fill="currentColor"
          />
        </svg>
      </ng-template>
      <ng-template #nextIcon>
        <svg width="6.4" height="12.8" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.01892 6.20399L1.88684 0.791051C1.64533 0.536325 1.22269 0.536325 0.981181 0.791051C0.739671 1.04578 0.739671 1.49155 0.981181 1.74627L5.81137 6.8408L0.981181 12.2537C0.739671 12.5085 0.739671 12.9542 0.981181 13.209C1.22269 13.4637 1.64533 13.4637 1.88684 13.209L7.01892 7.47762C7.20005 7.28657 7.20005 7.09553 7.20005 6.90448C7.20005 6.58608 7.13967 6.33135 7.01892 6.20399Z"
            fill="currentColor"
          />
        </svg>
      </ng-template>
      <sol-button
        [variant]="'text'"
        [size]="'large'"
        ariaLabel="{{ 'previousButton' | translate }}"
        [iconPositionedFront]="previousIcon"
        (onClick)="previousClicked()"
        [disabled]="minMonth()"
        [disabledAltState]="minMonth()"
      ></sol-button>
      <span class="sol-calendar-header-label"
        ><sol-button [variant]="'text'" [size]="'large'" [ariaLabel]="periodLabel" (onClick)="changeView()">{{ periodLabel }}</sol-button></span
      >
      <sol-button
        [variant]="'text'"
        [size]="'large'"
        ariaLabel="{{ 'nextButton' | translate }}"
        [iconPositionedFront]="nextIcon"
        (onClick)="nextClicked()"
        [disabled]="maxMonth()"
        [disabledAltState]="maxMonth()"
      ></sol-button>
    </div>
  `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      styles: [".sol-calendar-header{display:flex;align-items:center;padding:1rem .625rem}.sol-calendar-header .sol-calendar-header-label{flex:1;text-align:center;padding-left:.125rem}\n"]
    }]
  }], () => [{
    type: i1.MatCalendar
  }, {
    type: i1$1.DateAdapter
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [MAT_DATE_FORMATS]
    }]
  }, {
    type: i0.ChangeDetectorRef
  }], null);
})();
class WeekRangeSelectionStrategy {
  setStartingDay(value) {
    this.startingDay = value;
  }
  constructor(_dateAdapter) {
    this._dateAdapter = _dateAdapter;
  }
  selectionFinished(date) {
    return this._createWeekRange(date);
  }
  createPreview(activeDate) {
    return this._createWeekRange(activeDate);
  }
  _createWeekRange(date) {
    if (date) {
      const dow = this._dateAdapter.getDayOfWeek(date) + 1;
      const start = this._dateAdapter.addCalendarDays(date, -(dow + 6 - this.startingDay) % 7);
      const end = this._dateAdapter.addCalendarDays(start, 6);
      return new DateRange(start, end);
    }
    return new DateRange(null, null);
  }
  static {
    this.ɵfac = function WeekRangeSelectionStrategy_Factory(t) {
      return new (t || WeekRangeSelectionStrategy)(i0.ɵɵinject(i1$1.DateAdapter));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: WeekRangeSelectionStrategy,
      factory: WeekRangeSelectionStrategy.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(WeekRangeSelectionStrategy, [{
    type: Injectable
  }], () => [{
    type: i1$1.DateAdapter
  }], null);
})();
class CalendarComponent {
  constructor(dateAdapter, cdr, calendarService, _dateFormats, _rangeSelectionStrategy, rangeSelectionStrategy) {
    this.dateAdapter = dateAdapter;
    this.cdr = cdr;
    this.calendarService = calendarService;
    this._dateFormats = _dateFormats;
    this._rangeSelectionStrategy = _rangeSelectionStrategy;
    this.rangeSelectionStrategy = rangeSelectionStrategy;
    this.daysDisabled = [];
    this.displayWeeks = false;
    this.startingDay = 0;
    this.type = 'single-selection';
    this.min = null;
    this.max = null;
    this.specialDates = [];
    this.dateSelected = new EventEmitter();
    this.calendarHeader = CalendarHeaderComponent;
    this.fallbackLocaleWeekDayConfig = 'en-US';
    this.disabledDate = date => {
      return !this.daysDisabled.some(d => d === date.getDay());
    };
    this.dateselected = () => {
      if (this.type === 'week-selection' || this.type === 'multi-week-selection') {
        if (!this.calendarService.selectedWeek) {
          return new DateRange(null, null);
        }
        return this.calendarService.selectedWeek;
      } else if (this.type === 'range-selection') {
        return this.calendarService.selectedDateRange;
      } else {
        return this.calendarService.selectedDate;
      }
    };
    this._change = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
    this.dateAdapter.setLocale(navigator.language);
    this.dateAdapter.getFirstDayOfWeek = () => {
      return this.startingDay;
    };
    this.dateAdapter.getDayOfWeekNames = () => {
      const days = [1, 2, 3, 4, 5, 6, 7].map(day => {
        const dd = day < 10 ? `0${day}` : day;
        return new Date(`2017-01-${dd}T00:00:00+00:00`);
      });
      const DaysFormatted = this.setFormattedDaysByLanguage(days, window.navigator.language);
      if (this.isValidDaysFormat(DaysFormatted)) {
        return DaysFormatted;
      } else {
        return this.setFormattedDaysByLanguageOnValidationIssue(days, window.navigator.language);
      }
    };
  }
  setFormattedDaysByLanguageOnValidationIssue(days, language) {
    let DaysFormatted = this.setFormattedDaysByLanguage(days, language.substring(0, 2));
    if (this.isValidDaysFormat(DaysFormatted)) {
      return DaysFormatted;
    } else {
      DaysFormatted = this.setFormattedDaysByLanguage(days, this.fallbackLocaleWeekDayConfig);
      return DaysFormatted;
    }
  }
  setFormattedDaysByLanguage(days, language) {
    const formatter = new Intl.DateTimeFormat(language, {
      weekday: 'short',
      timeZone: 'UTC'
    });
    return days.map(date => formatter.format(date));
  }
  isValidDaysFormat(DaysFormatted) {
    for (let i = 0; i < DaysFormatted.length; i++) {
      if (DaysFormatted[i].length > 4) {
        return false;
      }
    }
    return true;
  }
  ngAfterViewInit() {
    if (this.type === 'week-selection' && !this._rangeSelectionStrategy || this.type === 'multi-week-selection' && !this._rangeSelectionStrategy) {
      throw new Error('week range selection startegy service must be provided.');
    }
    if (this.type === 'range-selection' && !this.rangeSelectionStrategy) {
      throw new Error('Default MatCalendar range selection stategy service must be provided.');
    }
    if (this.type === 'week-selection' || this.type === 'multi-week-selection') {
      this._rangeSelectionStrategy.setStartingDay(this.startingDay);
    }
  }
  ngAfterViewChecked() {
    this.calendarService.setState({
      min: this.min,
      max: this.max,
      daysDisabled: this.daysDisabled,
      type: this.type,
      _rangeSelectionStrategy: this._rangeSelectionStrategy,
      dateAdapter: this.dateAdapter,
      calendar: this.calendar,
      startingDay: this.startingDay
    });
    if (this.specialDates) {
      this.specialDates.forEach(specialDate => {
        const circle = document.createElement('div');
        let className;
        if (specialDate.color) {
          className = specialDate.color;
        } else {
          className = 'sol-calender-circle';
        }
        circle.className = className;
        if (specialDate.date) {
          const specialDates = this.cal.nativeElement.querySelector(`[aria-label="${this.dateAdapter.format(specialDate.date, this._dateFormats.display.dateA11yLabel)}"]`);
          if (!specialDates?.querySelector('.' + className)) {
            specialDates?.appendChild(circle);
          }
        }
      });
    }
  }
  selectedChangeHandler(selectedDate) {
    this.selectedValue = this.calendarService.selectedChangeHandler(selectedDate);
    this._change(this.selectedValue);
    this.calendar.focusActiveCell();
    this.calendar.updateTodaysDate();
    this.dateSelected.emit(this.selectedValue);
  }
  selected() {
    return date => {
      return this.calendarService.selected(date);
    };
  }
  singleSelection(value) {
    this.calendarService.selectedDate = value;
    if (value) {
      this.calendar._goToDateInView(value, 'month');
    }
    this.cdr.detectChanges();
    this.calendar.focusActiveCell();
    this.calendar.updateTodaysDate();
  }
  multiSingleSelection(value) {
    if (Array.isArray(value) && value.length > -1) {
      this.calendarService.dayselect = value;
      value.forEach(val => {
        this.calendar._goToDateInView(val, 'month');
      });
      this.cdr.detectChanges();
      this.calendar.focusActiveCell();
      this.calendar.updateTodaysDate();
    }
  }
  weekSelection(value) {
    this.calendarService.selectedWeek = value;
    if (value.start) {
      this.calendar._goToDateInView(value.start, 'month');
    }
    this.cdr.detectChanges();
    this.calendar.focusActiveCell();
    this.calendar.updateTodaysDate();
  }
  multiWeekSelection(value) {
    if (value) {
      this.calendarService.multiWeek = value;
      if (value && value[0]) {
        this.calendar._goToDateInView(value[0].start, 'month');
      }
      if (this.calendarService.multiWeek && this.calendarService.multiWeek.length > -1) {
        this.calendarService.selectedWeek = this.calendarService.multiWeek[0];
      }
      this.cdr.detectChanges();
      this.calendar.focusActiveCell();
      this.calendar.updateTodaysDate();
    }
  }
  rangeSelection(value) {
    this.calendarService.selectedDateRange = value;
    if (value.start) {
      this.calendar._goToDateInView(value.start, 'month');
    } else if (value.end) {
      this.calendar._goToDateInView(value.end, 'month');
    }
    this.cdr.detectChanges();
    this.calendar.focusActiveCell();
    this.calendar.updateTodaysDate();
  }
  writeValue(value) {
    if (this.type === 'single-selection') {
      this.singleSelection(value);
    } else if (this.type === 'multi-single-selection' && value) {
      this.multiSingleSelection(value);
    } else if (this.type === 'week-selection' && value) {
      this.weekSelection(value);
    } else if (this.type === 'range-selection' && value) {
      this.rangeSelection(value);
    } else {
      this.multiWeekSelection(value);
    }
  }
  registerOnChange(fn) {
    this._change = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  static {
    this.ɵfac = function CalendarComponent_Factory(t) {
      return new (t || CalendarComponent)(i0.ɵɵdirectiveInject(i1$1.DateAdapter), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(CalendarService), i0.ɵɵdirectiveInject(MAT_DATE_FORMATS), i0.ɵɵdirectiveInject(MAT_DATE_RANGE_SELECTION_STRATEGY, 8), i0.ɵɵdirectiveInject(MAT_DATE_RANGE_SELECTION_STRATEGY, 8));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: CalendarComponent,
      selectors: [["sol-calendar"]],
      viewQuery: function CalendarComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatCalendar, 5);
          i0.ɵɵviewQuery(_c0, 5, ElementRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.calendar = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cal = _t.first);
        }
      },
      inputs: {
        daysDisabled: "daysDisabled",
        displayWeeks: "displayWeeks",
        startingDay: "startingDay",
        type: "type",
        min: "min",
        max: "max",
        specialDates: "specialDates"
      },
      outputs: {
        dateSelected: "dateSelected"
      },
      features: [i0.ɵɵProvidersFeature([CalendarService, {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CalendarComponent),
        multi: true
      }])],
      decls: 3,
      vars: 6,
      consts: [[1, "sol-calender"], [3, "selected", "headerComponent", "dateFilter", "dateClass", "minDate", "maxDate", "selectedChange"], ["cal", ""]],
      template: function CalendarComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "mat-calendar", 1, 2);
          i0.ɵɵlistener("selectedChange", function CalendarComponent_Template_mat_calendar_selectedChange_1_listener($event) {
            return ctx.selectedChangeHandler($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance();
          i0.ɵɵproperty("selected", ctx.dateselected())("headerComponent", ctx.calendarHeader)("dateFilter", ctx.disabledDate)("dateClass", ctx.selected())("minDate", ctx.min)("maxDate", ctx.max);
        }
      },
      dependencies: [i1.MatCalendar],
      styles: [".sol-calender .sol-calender-circle,.sol-calender .circle-alt1,.sol-calender .circle-alt2,.sol-calender .circle-alt3,.sol-calender .circle-alt4{position:relative;width:.313rem;height:.313rem;border-radius:50%;top:calc(50% - .5rem);z-index:1;left:calc(50% - .1565rem)}.sol-calender .mat-calendar{border-radius:4px;background-color:#fff}.sol-calender .mat-calendar-table-header span{font-family:var(--typography-opensans-body-subtitle2-font-family);font-style:var(--typography-opensans-body-subtitle2-font-style);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);line-height:var(--typography-opensans-body-subtitle2-line-height);color:var(--color-interface-text700)}.sol-calender .mat-calendar-table-header .mat-calendar-table-header-divider{display:none}.sol-calender .mat-calendar-body{font-family:var(--typography-opensans-body-body3-font-family);font-weight:var(--typography-opensans-body-body3-font-weight);font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-body-body3-line-height)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content{flex-direction:column}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.sol-calender-circle{background:var(--color-interface-blue550)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt1{background:var(--circle-alt1-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt2{background:var(--circle-alt2-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt3{background:var(--circle-alt3-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt4{background:var(--circle-alt4-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected{background-color:var(--color-interface-blue550);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);line-height:var(--typography-opensans-body-subtitle2-line-height);font-family:var(--typography-opensans-body-subtitle2-font-family);font-style:var(--typography-opensans-body-subtitle2-font-style)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.sol-calender-circle{background:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt1{background:var(--circle-alt1-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt2{background:var(--circle-alt2-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt3{background:var(--circle-alt3-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt4{background:var(--circle-alt4-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-disabled .mat-calendar-body-cell-content{color:var(--color-globalstate-disabled-content)!important}.sol-calender .mat-calendar-body .mat-calendar-body-disabled>.mat-calendar-body-today{border:2px solid #c3c5c9!important}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content{color:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.sol-calender-circle{background:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt1{background:var(--circle-alt1-color-selected)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt2{background:var(--circle-alt2-color-selected)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt3{background:var(--circle-alt3-color-selected)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt4{background:var(--circle-alt4-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content{border-radius:50%;background-color:var(--color-interface-blue550);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);line-height:var(--typography-opensans-body-subtitle2-line-height);font-family:var(--typography-opensans-body-subtitle2-font-family);font-style:var(--typography-opensans-body-subtitle2-font-style);color:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.sol-calender-circle{background:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt1{background:var(--circle-alt1-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt2{background:var(--circle-alt2-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt3{background:var(--circle-alt3-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt4{background:var(--circle-alt4-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-in-preview{color:transparent}.sol-calender .mat-calendar-body .mat-calendar-body-in-preview:not(.sol-date-selected) .mat-calendar-body-cell-preview{background:var(--color-interface-background125)}.sol-calender .mat-calendar-body .mat-calendar-body-in-preview:not(.mat-calendar-body-disabled) .mat-calendar-body-cell-content{font-weight:700}.sol-calender .mat-calendar-body .mat-calendar-body-in-range:before{background:var(--color-interface-background100)}.sol-calender .mat-calendar-body .mat-calendar-body-in-range:not(.mat-calendar-body-disabled) .mat-calendar-body-cell-content{font-weight:700}.sol-calender .mat-calendar-body td:last-child .mat-calendar-body-in-range:before{width:95%;border-top-right-radius:62.438rem;border-bottom-right-radius:62.438rem}.sol-calender .mat-calendar-body td:last-child .mat-calendar-body-in-preview .mat-calendar-body-cell-preview{width:95%;border-top-right-radius:62.438rem;border-bottom-right-radius:62.438rem}.sol-calender .mat-calendar-body td:first-child .mat-calendar-body-in-range:before{left:5%;width:95%;border-top-left-radius:62.438rem;border-bottom-left-radius:62.438rem}.sol-calender .mat-calendar-body td:first-child .mat-calendar-body-in-preview .mat-calendar-body-cell-preview{left:5%;width:95%;border-top-left-radius:62.438rem;border-bottom-left-radius:62.438rem}.sol-calender .mat-calendar-body .mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border:2px solid var(--color-interface-blue550);font-weight:700}.sol-calender .mat-calendar-body .sol-week-selected:before{background:var(--color-interface-blue550)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background:var(--color-interface-blue550)}.sol-calender .mat-calendar-body .sol-date-selected:hover .mat-calendar-body-cell-content{background-color:var(--color-interface-blue550)!important}.sol-calender .mat-calendar-body .sol-date-selected:focus .mat-calendar-body-cell-content{background-color:var(--color-interface-blue550)!important;outline:none!important}.sol-calender .mat-calendar-body .mat-calendar-body-today.mat-calendar-body-selected{box-shadow:none}.sol-calender .mat-calendar-body .mat-calendar-body-label{opacity:0}.sol-calender .mat-calendar-body .mat-calendar-body-label[colspan=\"7\"]{display:none}.sol-calender .sol-first-date-of-month:before{background:conic-gradient(var(--color-interface-blue550) 0deg,var(--color-interface-blue550) 180deg,transparent 90deg,transparent 360deg)!important}.sol-calender .sol-first-date-of-month-range:before{border-top-left-radius:50%;border-bottom-left-radius:50%}.sol-calender .cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:transparent;outline:1px solid var(--color-globalstate-focus)}.sol-calender .mat-calendar-body-cell:not(.sol-date-selected):not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:var(--color-interface-background125);font-weight:700}.sol-calender .mat-calendar-body-cell:not(.sol-date-selected):not(.mat-calendar-body-disabled):focus>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:transparent;outline:1px solid var(--color-globalstate-focus)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarComponent, [{
    type: Component,
    args: [{
      selector: 'sol-calendar',
      template: `
    <div class="sol-calender">
      <mat-calendar
        #cal
        [selected]="dateselected()"
        [headerComponent]="calendarHeader"
        [dateFilter]="disabledDate"
        (selectedChange)="selectedChangeHandler($event)"
        [dateClass]="selected()"
        [minDate]="min"
        [maxDate]="max"
      ></mat-calendar>
    </div>
  `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [CalendarService, {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CalendarComponent),
        multi: true
      }],
      styles: [".sol-calender .sol-calender-circle,.sol-calender .circle-alt1,.sol-calender .circle-alt2,.sol-calender .circle-alt3,.sol-calender .circle-alt4{position:relative;width:.313rem;height:.313rem;border-radius:50%;top:calc(50% - .5rem);z-index:1;left:calc(50% - .1565rem)}.sol-calender .mat-calendar{border-radius:4px;background-color:#fff}.sol-calender .mat-calendar-table-header span{font-family:var(--typography-opensans-body-subtitle2-font-family);font-style:var(--typography-opensans-body-subtitle2-font-style);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);line-height:var(--typography-opensans-body-subtitle2-line-height);color:var(--color-interface-text700)}.sol-calender .mat-calendar-table-header .mat-calendar-table-header-divider{display:none}.sol-calender .mat-calendar-body{font-family:var(--typography-opensans-body-body3-font-family);font-weight:var(--typography-opensans-body-body3-font-weight);font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-body-body3-line-height)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content{flex-direction:column}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.sol-calender-circle{background:var(--color-interface-blue550)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt1{background:var(--circle-alt1-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt2{background:var(--circle-alt2-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt3{background:var(--circle-alt3-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-cell-content~.circle-alt4{background:var(--circle-alt4-color)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected{background-color:var(--color-interface-blue550);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);line-height:var(--typography-opensans-body-subtitle2-line-height);font-family:var(--typography-opensans-body-subtitle2-font-family);font-style:var(--typography-opensans-body-subtitle2-font-style)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.sol-calender-circle{background:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt1{background:var(--circle-alt1-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt2{background:var(--circle-alt2-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt3{background:var(--circle-alt3-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-cell .mat-calendar-body-selected~.circle-alt4{background:var(--circle-alt4-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-disabled .mat-calendar-body-cell-content{color:var(--color-globalstate-disabled-content)!important}.sol-calender .mat-calendar-body .mat-calendar-body-disabled>.mat-calendar-body-today{border:2px solid #c3c5c9!important}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content{color:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.sol-calender-circle{background:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt1{background:var(--circle-alt1-color-selected)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt2{background:var(--circle-alt2-color-selected)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt3{background:var(--circle-alt3-color-selected)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-cell-content~.circle-alt4{background:var(--circle-alt4-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content{border-radius:50%;background-color:var(--color-interface-blue550);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);line-height:var(--typography-opensans-body-subtitle2-line-height);font-family:var(--typography-opensans-body-subtitle2-font-family);font-style:var(--typography-opensans-body-subtitle2-font-style);color:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.sol-calender-circle{background:var(--color-button-text-normal)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt1{background:var(--circle-alt1-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt2{background:var(--circle-alt2-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt3{background:var(--circle-alt3-color-selected)}.sol-calender .mat-calendar-body .sol-date-selected .mat-calendar-body-cell-content~.circle-alt4{background:var(--circle-alt4-color-selected)}.sol-calender .mat-calendar-body .mat-calendar-body-in-preview{color:transparent}.sol-calender .mat-calendar-body .mat-calendar-body-in-preview:not(.sol-date-selected) .mat-calendar-body-cell-preview{background:var(--color-interface-background125)}.sol-calender .mat-calendar-body .mat-calendar-body-in-preview:not(.mat-calendar-body-disabled) .mat-calendar-body-cell-content{font-weight:700}.sol-calender .mat-calendar-body .mat-calendar-body-in-range:before{background:var(--color-interface-background100)}.sol-calender .mat-calendar-body .mat-calendar-body-in-range:not(.mat-calendar-body-disabled) .mat-calendar-body-cell-content{font-weight:700}.sol-calender .mat-calendar-body td:last-child .mat-calendar-body-in-range:before{width:95%;border-top-right-radius:62.438rem;border-bottom-right-radius:62.438rem}.sol-calender .mat-calendar-body td:last-child .mat-calendar-body-in-preview .mat-calendar-body-cell-preview{width:95%;border-top-right-radius:62.438rem;border-bottom-right-radius:62.438rem}.sol-calender .mat-calendar-body td:first-child .mat-calendar-body-in-range:before{left:5%;width:95%;border-top-left-radius:62.438rem;border-bottom-left-radius:62.438rem}.sol-calender .mat-calendar-body td:first-child .mat-calendar-body-in-preview .mat-calendar-body-cell-preview{left:5%;width:95%;border-top-left-radius:62.438rem;border-bottom-left-radius:62.438rem}.sol-calender .mat-calendar-body .mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border:2px solid var(--color-interface-blue550);font-weight:700}.sol-calender .mat-calendar-body .sol-week-selected:before{background:var(--color-interface-blue550)}.sol-calender .mat-calendar-body .sol-week-selected .mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background:var(--color-interface-blue550)}.sol-calender .mat-calendar-body .sol-date-selected:hover .mat-calendar-body-cell-content{background-color:var(--color-interface-blue550)!important}.sol-calender .mat-calendar-body .sol-date-selected:focus .mat-calendar-body-cell-content{background-color:var(--color-interface-blue550)!important;outline:none!important}.sol-calender .mat-calendar-body .mat-calendar-body-today.mat-calendar-body-selected{box-shadow:none}.sol-calender .mat-calendar-body .mat-calendar-body-label{opacity:0}.sol-calender .mat-calendar-body .mat-calendar-body-label[colspan=\"7\"]{display:none}.sol-calender .sol-first-date-of-month:before{background:conic-gradient(var(--color-interface-blue550) 0deg,var(--color-interface-blue550) 180deg,transparent 90deg,transparent 360deg)!important}.sol-calender .sol-first-date-of-month-range:before{border-top-left-radius:50%;border-bottom-left-radius:50%}.sol-calender .cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:transparent;outline:1px solid var(--color-globalstate-focus)}.sol-calender .mat-calendar-body-cell:not(.sol-date-selected):not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:var(--color-interface-background125);font-weight:700}.sol-calender .mat-calendar-body-cell:not(.sol-date-selected):not(.mat-calendar-body-disabled):focus>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:transparent;outline:1px solid var(--color-globalstate-focus)}\n"]
    }]
  }], () => [{
    type: i1$1.DateAdapter
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: CalendarService
  }, {
    type: undefined,
    decorators: [{
      type: Inject,
      args: [MAT_DATE_FORMATS]
    }]
  }, {
    type: WeekRangeSelectionStrategy,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [MAT_DATE_RANGE_SELECTION_STRATEGY]
    }]
  }, {
    type: i1.DefaultMatCalendarRangeStrategy,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [MAT_DATE_RANGE_SELECTION_STRATEGY]
    }]
  }], {
    daysDisabled: [{
      type: Input
    }],
    displayWeeks: [{
      type: Input
    }],
    startingDay: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    specialDates: [{
      type: Input
    }],
    dateSelected: [{
      type: Output
    }],
    calendar: [{
      type: ViewChild,
      args: [MatCalendar]
    }],
    cal: [{
      type: ViewChild,
      args: ['cal', {
        read: ElementRef
      }]
    }]
  });
})();
class CalendarModule {
  static {
    this.ɵfac = function CalendarModule_Factory(t) {
      return new (t || CalendarModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CalendarModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [CalendarService],
      imports: [CommonModule, ButtonModule, MatDatepickerModule, MatNativeDateModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CalendarModule, [{
    type: NgModule,
    args: [{
      declarations: [CalendarComponent, CalendarHeaderComponent],
      imports: [CommonModule, ButtonModule, MatDatepickerModule, MatNativeDateModule, TranslationModule],
      exports: [CalendarComponent, CalendarHeaderComponent],
      providers: [CalendarService]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CalendarComponent, CalendarHeaderComponent, CalendarModule, WeekRangeSelectionStrategy };
